import * as React from 'react';
import { SVGProps } from 'react';

const IconRUOSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1v5.454l-2.849 4.144 10.772-1.346L17 11.454V6h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-8Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 16.108 6.436 17.803l-3.084 5.064C2.44 24.194 3.39 26 5 26h17.999c1.61 0 2.56-1.806 1.648-3.133L20 16.108ZM11 22a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm3.5-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm3.5 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default IconRUOSizeL;
